import storeManager from '../../../store/StoreManager';
import { addClipartModel } from '../../../actions/AccordionActions';
import zipLoader from '../../../components/accordion/clipartUtils/ZipLoader';
import appParameters from '../../../components/utils/AppParameters';
import moodsUtils from '../../../components/utils/MoodsUtils';
import masterUniverseUtils from '../../utils/MasterUniverseUtils';
import localesManager from '../../../locales/LocalesManager';
import configuration from '../../../constants/Configuration';

const clipartParserJSONNew = {
    cartoonistEffects: undefined,
    frames: undefined,

    parseClipartModel(jsonObject, isEffect = false, effectsTitle = '', isFrames = false) {
        if (!jsonObject || jsonObject.length < 1) {
            this.addClipartModelHandler({items:[], captionKey: appParameters.currentTheme});
            return;
        }

        const categories = this.getCategories(jsonObject); // needs also to sort the categories by a categoryPosition property
        var i;
        var j;
        var clipartModel = {};
        var item;
        let printCategory;

        if (!isEffect)
            clipartModel.captionKey = categories[0].items[0].theme;

        clipartModel.items = [];

        for (i=0; i<categories.length; i++) {
            var object = categories[i];
            let isPrint = false;

            item = {};

            if (isEffect)
                item.title = effectsTitle;
            else
                item.title = this.getCategoryTitle(object.caption, clipartModel.captionKey);

            item.items = [];

            for (j=0; j<object.items.length; j++) {
                var resourceObject = object.items[j];

                if (resourceObject.hidden < 1) // don't add hidden elements
                    continue;
                else {
                    if (configuration.IS_PROD() && resourceObject.hidden == 1)  // 0 - hidden, 1 - only stage, 2 - stage and prod
                        continue;
                }

                var resource = {};

                resource.title = this.getTitle(resourceObject)
                resource.logicalName = this.removeElementFromLogicalName(resourceObject.logicalname, '_svg'); // rename to logicalName

                if (resourceObject.type === 'prints') {
                    resource.isPrint = true;
                    isPrint = true;
                }

                if (resourceObject.theme != 'cartoonist_effects')
                    resource.theme = resourceObject.theme;

                this.parseMoods(resource, resourceObject.moods);

                this.buildHref(resource);
                this.buildThumbnail(resource);

                if (resourceObject.width > 0 && resourceObject.height > 0) {
                    resource.width = resourceObject.width;
                    resource.height = resourceObject.height;
                }

                if (this.isVisibleItem(resource))
                    item.items.push(resource);
            }

            if (isPrint)
                printCategory = item;
            else
                clipartModel.items.push(item);
        }

        if (printCategory)
            clipartModel.items.push(printCategory);

        if (isFrames) {
            this.frames = clipartModel.items[0];
        } else if (isEffect) {
            this.cartoonistEffects = clipartModel.items[0];
        } else {
            this.addClipartModelHandler(clipartModel);
        }
    },
    isVisibleItem(item) {
        var isSwedish = (appParameters.locale == 'sv_SE') ? true : false;
        var forbiddenElements = [];

        if (isSwedish)
            forbiddenElements = ['alphabet_planet_ae_theme_characters_ae_upper', 'alphabet_planet_ae_theme_characters_ae_lower', 'alphabet_planet_oe_theme_characters_oe_upper', 'alphabet_planet_oe_theme_characters_oe_lower', 'alphabet_planet_ae_theme_house_front', 'alphabet_planet_oe_theme_house_front'];
        else
            forbiddenElements = ['alphabet_planet_ae_theme_alphabet_ae_upper_swedish', 'alphabet_planet_ae_theme_alphabet_ae_lower_swedish', 'alphabet_planet_oe_theme_alphabet_oe_upper_swedish', 'alphabet_planet_oe_theme_alphabet_oe_lower_swedish', 'alphabet_planet_ae_theme_house_front_swedish', 'alphabet_planet_oe_theme_backgrounds_house_front', 'alphabet_planet_oe_theme_house_front_sweedish'];

        if (forbiddenElements.indexOf(item.logicalName) != -1)
            return false;
        else
            return true;
    },
    getCategoryTitle(category, themeName) {
        var captionName = themeName + '_'+ category;
        var translation = localesManager.getThemeCategoryCaption(captionName);

        if (translation != captionName)
            return translation;
        else
            return localesManager.getThemeCategoryCaption(category);
    },
    getTitle(item) {
        if (!item.translations)
            return item.logicalname;
        else {
            var translation = item.translations[masterUniverseUtils.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (item.translations['en_US'])
                return item.translations['en_US'];
            else
                return item.logicalname;
        }
    },
    getCategories(array) {
        var categoriesMap = [];
        var categories = [];
        var categoriesArray = [];
        var i;
        var backgroundsItems = ['backgrounds'];
        var charactersItems = ['people', 'characters'];
        var propsItems = ['props', 'rekvisita', 'stone_age__props', 'bronze_age__props', 'iron_age__props'];
        var backgroundsValue = '';
        var charactersValue = '';
        var propsValue = '';

        for (i=0; i<array.length; i++) {
            var category = array[i].type;

            if (!categoriesMap[category]) {
                if (backgroundsItems.indexOf(category) != -1)
                    backgroundsValue = category;
                else {
                    if (charactersItems.indexOf(category) != -1)
                        charactersValue = category;
                    else {
                        if (propsItems.indexOf(category) != -1)
                            propsValue = category;
                        else
                            categoriesArray.push(category);
                    }
                }

                categoriesMap[category] = {'caption': category, 'items': []};
            }

            categoriesMap[category].items.push(array[i]);
        }

        categoriesArray = categoriesArray.sort();

        var firstCategories = [];

        if (backgroundsValue != '')
            firstCategories = [backgroundsValue]; // backgrounds should be the first item

        if (charactersValue != '')
            firstCategories.push(charactersValue);

        categoriesArray = firstCategories.concat(categoriesArray); // characters should be the second item

        if (propsValue != '')
            categoriesArray = categoriesArray.concat([propsValue]); // props should be the last item

        for (i=0; i<categoriesArray.length; i++) {
            var key = categoriesArray[i];
            categoriesMap[key].items = this.sortElementsByPosition(categoriesMap[key].items);
            categories.push(categoriesMap[key]);
        }

        return categories;
    },
    sortElementsByPosition(array) {
        array.sort(function(a, b){return a.position - b.position});

        return array;
    },
    parseMoods(resource, moods) {
        if (moods == undefined)
            resource.moods = [];
        else
            resource.moods = moods;
    },
    buildThumbnail(resource){
        const thumbsPrefix = appParameters.SVG_URL();
        var mood = '';

        if (resource.moods.length > 0)
            mood = resource.moods[0];

        resource.thumbnailUrl = thumbsPrefix + 'thumbnails-content/' + resource.logicalName + '_' + mood + '_svg.png';

    },
    buildHref(resource) {
        const hrefPrefix = appParameters.SVG_URL();
        var href = hrefPrefix + resource.logicalName;
        var mood = '';

        if (resource.moods.length > 0)
            mood = resource.moods[0];

        href = href + '_'+ mood + '.svg';

        resource.href = href;
    },
    removeElementFromLogicalName(logicalName, deletedElement) {
        if (!logicalName)
            return '';

        var index = logicalName.indexOf(deletedElement);

        if (index > 0)
            logicalName = logicalName.substring(0, index);

        if (logicalName.charAt(logicalName.length-1) == '_')
            logicalName = logicalName.substring(0, logicalName.length-1);

        return logicalName;
    },
    addClipartModelHandler(clipartModel) {
        moodsUtils.clipartModel = clipartModel;

        const state = storeManager.getState();

        if (state.music.soundClipartModel == undefined)
            zipLoader.loadData('audio');

        this.updateClipartModelToState();
    },
    updateClipartModelToState() {
        const store = storeManager.getStore();
        store.dispatch(addClipartModel(moodsUtils.clipartModel));
    },
    parseSearchItems(items, category) {
        var i;
        var props = [];
        var characters = [];
        var backgrounds = [];
        var frames = [];
        var effects = [];
        var others = [];
        var newItems = [];
        var propsItems = ['props', 'rekvisita', 'stone_age__props', 'bronze_age__props', 'iron_age__props'];
        var charactersItems = ['people', 'characters'];
        var backgroundsItems = ['backgrounds'];


        for (i=0; i<items.length; i++) {
            var resourceObject = items[i];
            var resource = {};

            resource.title = this.getTitle(resourceObject)
            resource.logicalName = this.removeElementFromLogicalName(resourceObject.logicalname, '_svg'); // rename to logicalName

            if (resourceObject.theme != 'cartoonist_effects')
                resource.theme = resourceObject.theme;

            this.parseMoods(resource, resourceObject.moods);

            this.buildHref(resource);
            this.buildThumbnail(resource);

            if (category == 'all') {
                if (backgroundsItems.indexOf(resourceObject.type) != -1) {
                    if (resourceObject.theme == 'frames')
                        frames.push(resource);
                    else
                        backgrounds.push(resource);
                } else {
                    if (charactersItems.indexOf(resourceObject.type) != -1) {
                        characters.push(resource);
                    } else {
                        if (propsItems.indexOf(resourceObject.type) != -1) {
                            if (resourceObject.theme == 'cartoonist_effects')
                                effects.push(resource);
                            else
                                props.push(resource);
                        } else
                            others.push(resource);
                    }
                }
            } else {
                newItems.push(resource);
            }

            if (items[i].type == "backgrounds")
                resource.isBackground = true;
        }

        if (category == 'all') {
            newItems = props.concat(characters);
            newItems = newItems.concat(backgrounds);
            newItems = newItems.concat(frames);
            newItems = newItems.concat(effects);
            newItems = newItems.concat(others);

            return newItems;
        } else {
            return newItems;
        }
    }
};

export default clipartParserJSONNew;


/** WEBPACK FOOTER **
 ** ./src/components/accordion/clipartUtils/ClipartParserJSONNew.js
 **/